import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import React, { FC } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { CURRENCY_TRANSLATION_KEYS } from 'partner360/components/currenciesButtons/translations'
import { selectCurrencyOptions, selectNetNdpOptions } from 'partner360/features/QBR'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { TRANSLATION_KEYS } from '../../../../../../../../../translations'
import { ROUNDING_VALUES } from '../../../../configs'
import { SettingsSwitcher } from '../../../settingsSwitcher/SettingsSwitcher'
import styles from '../../QbrSettingsForm.module.scss'

import { useFormCurrencySettings } from './hooks/useFormCurrencySettings'

export const CurrencySettings: FC = () => {
  const netNdpOptions = useSelector(selectNetNdpOptions)
  const currencyOptions = useSelector(selectCurrencyOptions)

  const {
    currencyValue,
    isCurrencyModified,
    isCurrencyDisabled,
    changeCurrency,
    roundingValue,
    isRoundingModified,
    changeRounding,
    netNdpValue,
    isNetNdpModified,
    changeNetNdp,
  } = useFormCurrencySettings()

  return (
    <div>
      <div className={styles.title}>
        <Translation text={TRANSLATION_KEYS.settings.titleSwitcherSettings} />
      </div>
      <RenderWhen condition={Boolean(netNdpOptions || currencyOptions)}>
        <div className={styles.subTitle}>
          <Translation text={TRANSLATION_KEYS.settings.currencyAndValueType} />
        </div>

        <div className={styles.switcherWrapper}>
          <SettingsSwitcher
            margin={'md'}
            activeOption={netNdpValue}
            onChangeActiveOption={changeNetNdp}
            options={netNdpOptions as ActualsValueTypes[]}
            isChanged={isNetNdpModified}
          />
          <SettingsSwitcher
            margin={'md'}
            activeOption={currencyValue}
            onChangeActiveOption={changeCurrency}
            options={
              isCurrencyDisabled && !currencyOptions.includes('USD')
                ? ['USD', ...currencyOptions]
                : currencyOptions
            }
            isChanged={isCurrencyModified}
            isDisabled={isCurrencyDisabled}
            disabledTooltip={
              <Translation text={CURRENCY_TRANSLATION_KEYS.multipleLocalCurrencies} />
            }
          />
        </div>
      </RenderWhen>
      <div>
        <div className={styles.subTitle}>
          <Translation text={TRANSLATION_KEYS.settings.rounding} />
        </div>
      </div>
      <SettingsSwitcher
        margin={'md'}
        activeOption={roundingValue}
        onChangeActiveOption={changeRounding}
        options={ROUNDING_VALUES}
        isChanged={isRoundingModified}
      />
    </div>
  )
}
